class ImageProductVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
    this.selects = Array.from(this.querySelectorAll('select[data-option-position]'));
    this.hiddenInput = this.querySelector('.product-variant-id');
    this.productForm = this.closest('product-form');

    this.selects.forEach((select) => select.addEventListener('change', this.updateVariant.bind(this)));
  }

  getSelectedOptionValues() {
    return this.selects
      .slice()
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((select) => select.value || null);
  }

  updateVariant() {
    const selectedValues = this.getSelectedOptionValues();
    const allSelected = selectedValues.every(Boolean);
    const variant = allSelected
      ? this.variants.find((variant) => {
          const variantOptions = [variant.option1, variant.option2, variant.option3];
          return selectedValues.every((value, index) => variantOptions[index] === value);
        })
      : null;

    if (!this.productForm || typeof this.productForm.toggleSubmitButton !== 'function') return;

    if (variant) {
      this.hiddenInput.value = variant.id;
      this.productForm.toggleSubmitButton(!variant.available, variant.available ? null : window.variantStrings.soldOut);
    } else {
      this.hiddenInput.value = '';
      this.productForm.toggleSubmitButton(true);
    }
  }
}

customElements.define('image-product-variant-picker', ImageProductVariantPicker);
